

import { request } from "@weapp/utils";
import { getCookie, getQueryString, isE10Self, mainHost } from "../utils";
const ETEAMSID = window.ETEAMSID;
const host = mainHost();

export const getUuid = () => {
    return request({
        url: `/api/basicserver/account/qureyKeyByUuid`,
        method: "post",
    });
};
export const getsiblingstenant = () => {
    return request({
        url: `/api/app/basicserver/siblingstenant`,
        method: "get",
    });
};
//查询团队信息
export const queryTenant = (params: any) => {
    const checkToken = getQueryString("checkToken")
    if (checkToken){
        params.changeToken = checkToken;
    }
    return request({
        url: `/${checkToken ? 'papi' : 'api'}/basicserver/addteam/queryTenant`,
        method: "get",
        params,
    });
};
//申请加入团队
export const applyTenant = (params: any) => {
    const checkToken = getQueryString("checkToken")
    if (checkToken){
        params.changeToken = checkToken;
    }
    return request({
        url: `/${checkToken ? 'papi' : 'api'}/basicserver/addteam/saveApply`,
        method: "get",
        params,
    });
};

//组织名称查重判断
export const checkTenantAuth = (tenantName: string) => {
    return request({
        url: '/papi/basicserver/tenantAuth/checkTenantAuth',
        method: 'post',
        data: {
            tenantName
        }
    })
}
//取消申请加入团队
export const cancleApply = (body: any) => {
    const checkToken = getQueryString("checkToken")
    return request({
        url: checkToken ?
          `/papi/basicserver/addteam/cancelApplyMessageNew${checkToken?`?changeToken=${checkToken}`:''}` :
          `/api/basicserver/operaterecord/cancelApplyMessageNew`,
        method: "post",
        data: body
    });
};
//创建团队
export const createTeams = (params: any) => {
    const checkToken = getQueryString("checkToken")
    if (checkToken){
        params.changeToken = checkToken;
    }
    params['language'] = getCookie('langType') || 'zh_CN';
    return request({
        url: isE10Self() ?
          `/${checkToken ? 'papi' : 'api'}/basicserver/addteam/createTenantTemp` :
          `/${checkToken ? 'papi' : 'api'}/basicserver/addteam/createTenant`,
        // url: `/api/basicserver/addteam/createTenant`,
        method: "get",
        params,
        timeout: 0
    });
};